'use client'

import { useState } from 'react'
import { Button, Popover } from '@indxsearch/systm'
import { Ai_agent, Chevron_down, Terminal, Check, External_link } from '@indxsearch/pixl'
import { copyText } from '@/lib/copyText'
import styles from './ForAgentsMenu.module.css'

const SKILL_INSTALL = 'npx skills add indxSearch/skill-indx-search'

// The same opening line for both assistants: it points them at the site's llms.txt.
const ASK = encodeURIComponent('Read https://indx.co/llms.txt so I can ask questions about Indx.')

/** Hero dropdown with everything a coding agent needs: the skill, agent-readable docs, and a chat to ask. */
export default function ForAgentsMenu() {
  const [copied, setCopied] = useState(false)

  const copySkill = async () => {
    if (!(await copyText(SKILL_INSTALL))) return
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Popover
      align="start"
      className={styles.menu}
      aria-label="For agents"
      trigger={
        <Button size="default" variant="primary" iconLeft={<Ai_agent />} iconRight={<Chevron_down />}>
          For agents
        </Button>
      }
    >
      <Button
        size="default"
        variant="ghost"
        className={styles.item}
        iconRight={copied ? <Check /> : <Terminal />}
        onClick={copySkill}
        title={SKILL_INSTALL}
      >
        {copied ? 'Copied install command' : 'Install the Indx skill'}
      </Button>

      <hr className={styles.divider} />

      <Button size="default" variant="ghost" className={styles.item} href="https://docs.indx.co/guides/ai-agents">
        Indx and AI agents
      </Button>
      <Button size="default" variant="ghost" className={styles.item} href="https://skills.sh/indxsearch/skill-indx-search/indx-search">
        About the skill
      </Button>
      <Button size="default" variant="ghost" className={styles.item} href="https://docs.indx.co/llms-full.txt">
        Docs as one file (llms-full.txt)
      </Button>

      <hr className={styles.divider} />

      <Button
        size="default"
        variant="ghost"
        className={styles.item}
        iconRight={<External_link />}
        href={`https://claude.ai/new?q=${ASK}`}
        target="_blank"
        rel="noopener"
      >
        Ask Claude
      </Button>
      <Button
        size="default"
        variant="ghost"
        className={styles.item}
        iconRight={<External_link />}
        href={`https://chatgpt.com/?q=${ASK}`}
        target="_blank"
        rel="noopener"
      >
        Ask ChatGPT
      </Button>
    </Popover>
  )
}
